<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllButtonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile
                @click="
                  printAllStockTransferRequest('printStockTransferRequest')
                "
              >
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllStockTransferRequest()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-tansition"
                offest-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-tansition"
                offest-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="stockTransferRequestStatusList"
                label="Choose Stock Transfer Status ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm4 v-if="user.role.roleName == 'ADMIN'">
              <v-autocomplete
                v-model="queryParams.fromWarehouseId"
                :items="warehouseList"
                color="blue-grey lighten-2"
                :hide-no-data="true"
                label="Choose From Warehouse..."
                item-text="name"
                menu-props="auto"
                item-value="id"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4 v-if="user.role.roleName == 'ADMIN'">
              <v-autocomplete
                :items="warehouseList"
                :hide-no-data="true"
                color="blue-grey lighten-2"
                label="Choose To Warehouse..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                v-model="queryParams.toWarehouseId"
              ></v-autocomplete>
            </v-flex>
            <v-flex
              sm4
              v-if="
                user.role.roleName == 'WAREHOUSE_MANAGER' ||
                user.role.roleName == 'WAREHOUSE_STAFF' ||
                user.role.roleName == 'BRANCH_ADMIN'
              "
            >
              <v-autocomplete
                :items="typeList"
                label="Choose Type ..."
                :hide-no-data="true"
                item-text="label"
                menu-props="auto"
                v-model="type"
                v-on:change="changeType()"
              ></v-autocomplete>
            </v-flex>
            <v-flex
              sm4
              v-if="
                user.role.roleName == 'WAREHOUSE_MANAGER' ||
                user.role.roleName == 'WAREHOUSE_STAFF' ||
                user.roleName == 'BRANCH_ADMIN'
              "
            >
              <v-autocomplete
                :items="warehouseList"
                :hide-no-data="true"
                color="blue-grey lighten-2"
                label="Choose Warehouse..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                v-model="queryParams.warehouseId"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="stockTransferRequestList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.status }}</td>
              <td>
                {{ props.item.issueDateInMilliSeconds | format-ms-date }}
              </td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.fromWarehouseName }}</td>
              <td>{{ props.item.toWarehouseName }}</td>
              <td>{{ props.item.description }}</td>
              <td>
                {{
                  props.item.updatedDateInMilliSeconds
                    | format-ms-date-time
                }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
              <td>
                <v-btn
                  color="primary"
                  @click.stop="
                    reprintStockTransferRequestInvoice(props.item.id)
                  "
                  >REPRINT</v-btn
                >
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <div
      id="printStockTransferRequest"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">
          Stock Transfer Request Report
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="text-align: left">Issue Date</th>
              <th style="text-align: left">Issue No</th>
              <th style="text-align: left">From Warehouse</th>
              <th style="text-align: left">To Warehouse</th>
              <th style="text-align: left">Stock Transfer Status</th>
              <th style="text-align: left">Description</th>
              <th style="text-align: left">Updated Date</th>
              <th style="text-align: left">Updated By</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in allStockTransferRequestList"
              :key="index"
            >
              <td>{{ item.issueDateInMilliSeconds | format-ms-date }}</td>
              <td>{{ item.issueNo }}</td>
              <td>{{ item.fromWarehouseName }}</td>
              <td>{{ item.toWarehouseName }}</td>
              <td>{{ item.status }}</td>
              <td>{{ item.description }}</td>
              <td>
                {{
                  item.updatedDateInMilliSeconds | format-ms-date-time
                }}
              </td>
              <td>{{ item.updatedBy }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- dialog -->
    <StockTransferRequestExcel
      :isOpen="openDialog"
      v-on:change="dialogClose()"
    ></StockTransferRequestExcel>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { stockTransferRequestService } from "../../services/stock-transfer-request-service";
import { warehouseService } from "../../services/warehouse-service";
import StockTransferRequestExcel from "../../components/stock-transfer-request/StockTransferRequestExcel";

export default {
  name: "StockTransferRequestList",

  components: { StockTransferRequestExcel },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Warehouse Management",
        disabled: true,
      },
      {
        text: "Stock Transfer Request",
        disabled: true,
      },
    ],
    stockTransferRequestStatusList: [],
    typeList: [
      { label: "TRANSFER", value: "TRANSFER" },
      { label: "RECEIVE", value: "RECEIVE" },
    ],
    headers: [
      { text: "Action", value: "name", sortable: false },
      { text: "Stock Transfer Status", value: "status" },
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "From Warehouse", value: "fromWarehouse.name" },
      { text: "To Warehouse", value: "toWarehouse.name" },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Reprint", align: "center", sortable: false },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "issueDate",
      totalItems: 0,
    },
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      status: "",
      fromWarehouseId: "",
      toWarehouseId: "",
      warehouseId: "",
      updateUserId: "",
    },
    rowsPerPageItems: [25, 50, 100],
    totalRows: 0,
    printAllButtonLoading: false,
    openDialog: false,
    warehouseList: [],
    stockTransferRequestList: [],
    allStockTransferRequestList: [],
    type: "",
    clonequeryParams: new Object(),
  }),

  watch: {
    pagination: {
      handler() {
        this.getStockTransferRequestList();
        this.getAllStockTransferRequestList();
      },
      deep: true,
    },
  },

  created() {
    if (
      this.user.role.roleName == "WAREHOUSE_MANAGER" ||
      this.user.role.roleName == "WAREHOUSE_STAFF" ||
      this.user.roleName == "BRANCH_ADMIN"
    ) {
      this.type = "TRANSFER";
      /*if (this.user.role.roleName == "WAREHOUSE_STAFF") {
        this.queryParams.updateUserId = this.user.id;
      }*/
    }

    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }

    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }

    if (this.user.role.roleName == "ADMIN") {
      if (this.$route.query.fromWarehouseId) {
        this.queryParams.fromWarehouseId = this.$route.query.fromWarehouseId;
      }

      if (this.$route.query.toWarehouseId) {
        this.queryParams.toWarehouseId = this.$route.query.toWarehouseId;
      }
    }

    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }

    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }

    if (this.$route.query.updateUserId) {
      this.queryParams.updateUserId = this.$route.query.updateUserId;
    }

    if (this.$route.query.page) {
      this.queryParams.page = this.$route.query.page;
    }

    if (this.$route.query.size) {
      this.queryParams.size = this.$route.query.size;
    }
    this.getWarehouseList();
    this.onSearch();
    this.changeType();
  },

  methods: {
    onSearch() {
      if (
        this.user.role.roleName == "WAREHOUSE_MANAGER" ||
        this.user.role.roleName == "WAREHOUSE_STAFF" ||
        this.user.roleName == "BRANCH_ADMIN"
      ) {
        if (this.type === "TRANSFER") {
          this.queryParams.fromWarehouseId = this.user.warehouseId;
          this.queryParams.toWarehouseId = this.queryParams.warehouseId;
        }

        if (this.type === "RECEIVE") {
          this.queryParams.toWarehouseId = this.user.warehouseId;
          this.queryParams.fromWarehouseId = this.queryParams.warehouseId;
        }
      }

      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "stock-transfer-requests",
        query: this.queryParams,
      });
      this.clonequeryParams = Object.assign({}, this.queryParams);
      this.getStockTransferRequestList();
      this.getAllStockTransferRequestList();
    },

    dialogClose() {
      this.openDialog = false;
      this.getStockTransferRequestList();
    },

    changeType() {
      if (this.type === "TRANSFER" || this.user.roleName == "ADMIN") {
        this.stockTransferRequestStatusList = [];
        this.stockTransferRequestStatusList.push(
          "DRAFT",
          "REQUEST",
          "REJECT",
          "CONFIRM",
          "FINISHED",
          "CANCEL"
        );
      }
      if (this.type === "RECEIVE") {
        this.stockTransferRequestStatusList = [];
        this.stockTransferRequestStatusList.push(
          "REQUEST",
          "REJECT",
          "CONFIRM",
          "FINISHED"
        );
      }
    },

    getStockTransferRequestList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockTransferRequestService
        .getStockTransferRequestList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.stockTransferRequestList =
              res.data.stockTransferRequestDTOList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    getAllStockTransferRequestList() {
      stockTransferRequestService
        .getAllStockTransferRequestList(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allStockTransferRequestList =
              res.data.stockTransferRequestDTOList;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    printAllStockTransferRequest(divName) {
      this.printAllButtonLoading = true;
      stockTransferRequestService
        .getAllStockTransferRequestList(this.clonequeryParams)
        .then((res) => {
          if (res.data) {
            this.allStockTransferRequestList =
              res.data.stockTransferRequestDTOList;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },

    getWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
          let findAll = {
            id: "",
            name: "---All---",
          };
          this.warehouseList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },

    reprintStockTransferRequestInvoice(id) {
      stockTransferRequestService
        .printStockTransferRequestById(id)
        .then((res) => {
          var blob = res;
          commonService.showWindowDialog(blob, "invoice-" + id);
        });
    },

    onEdit(stockTransferRequest) {
      //go to details page
      this.$router.push("/stock-transfer-request/" + stockTransferRequest.id);
    },

    onRegister() {
      this.$router.push("/stock-transfer-request/new");
    },
    exportAllStockTransferRequest() {
      this.printAllButtonLoading = true;
      stockTransferRequestService
        .exportAllStockTransferRequestExcel(this.clonequeryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllButtonLoading = false;
        });
    },
  },
};
</script>